import { getSessionId, retrieve, STORAGE_KEYS, store } from '@/utils/storage';
import { LOCAL_STORAGE } from '@/utils/constants';

export const getSeenZones = (): string[] => {
    try {
        const stored = retrieve(STORAGE_KEYS.EXCLUSIVE_POPUP_SEEN_ZONES, 'local');
        return stored ? JSON.parse(stored) : [];
    } catch {
        console.error('Error getting exclusive zones seen from local storage');
        return [];
    }
};

export const setSeenZones = (zones: string[]) => {
    try {
        store({ key: STORAGE_KEYS.EXCLUSIVE_POPUP_SEEN_ZONES, value: JSON.stringify(zones) }, 'local');
        const sessionId = getSessionId();
        if (sessionId) {
            store({ key: LOCAL_STORAGE.EXCLUSIVE_MODAL_SEEN_THIS_SESSION, value: sessionId }, 'local');
        }
    } catch {
        console.error('Error setting exclusive zones seen  in local storage');
    }
};

export { processExclusiveZone } from './process-exclusive-zone';
export type { ProcessExclusiveZoneResult } from './process-exclusive-zone';
